import { Deploy } from '@block-explorer/entities';
import { MessageData } from './types';

const prepareActionMessageData = (deploy: Deploy): MessageData => {
  const { entryPoint } = deploy;
  const entryPointName = entryPoint?.name || '';
  const actionName = {
    set_associated_keys: 'Update account',
  };

  return {
    entryPointName: entryPointName,
    actionName: actionName[entryPointName] || entryPointName,
  };
};

const prepareActionMessageDataForHome = (
  deploy: Deploy
): MessageData | null => {
  const { callerPublicKey, callerHash } = deploy;

  const messageObject = prepareActionMessageData(deploy);
  const actionOutput = {
    callerPrefix: 'by',
    callerAccount: {
      publicKey: callerPublicKey || callerHash,
    },
  };

  if (messageObject === null) {
    return null;
  }

  return {
    ...messageObject,
    ...actionOutput,
  };
};

export const associatedKeyMessage = () => {
  const getRelevantAccountHashesFromArgs = () => {
    return [];
  };

  return {
    prepareActionMessageData,
    prepareActionMessageDataForHome,
    getRelevantAccountHashesFromArgs,
  };
};
